import { WebPortalService } from "../resource";

const PilotNumberV4Module = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    }
  },
  actions: {
    createData({ commit, state }, data) {
      return WebPortalService.PilotNumberCreateV4(data);
    },
    updateData({ commit, state }, data) {
      // Pilot rows are updated via the generic v4 subscriber update endpoint
      // (SubsUpdateV4 — /v4/number/update). No pilot-specific update route
      // exists on the backend; the generic handler operates on any subs id.
      return WebPortalService.NumberUpdateV4(data);
    },
    deleteData({ commit, state }, data) {
      return WebPortalService.PilotNumberDeleteV4(data);
    },
    syncPackage({ commit, state }, data) {
      return WebPortalService.SyncPackage(data);
    },
    async listData({ commit, state }) {
      try {
        const data = await WebPortalService.PilotNumberListV4();
        commit("SET_DATA", data.data.Data == null ? [] : data.data.Data);
      } catch {
        commit("SET_DATA", []);
      }
    },
    async listDataByEnterprise({ commit, state }, param) {
      try {
        const data = await WebPortalService.PilotNumberListByEnterpriseV4(param);
        commit("SET_DATA", data.data.Data == null ? [] : data.data.Data);
      } catch {
        commit("SET_DATA", []);
      }
    }
  },
  getters: {
    getData(state) {
      return state.data;
    },
    getRealNumber: state => entId => {
      return state.data.filter(m => m.EnterpriseID == entId && m.Type == 4);
    }
  }
};

export default PilotNumberV4Module;
